let TLSortBy=document.querySelector('#TLsortBy');
let formTL=document.querySelector('#frm-tl');
let tLCategories=document.querySelector('#tLCategories');
// TLSortBy.addEventListener("change", function(event){
//     formTL.submit();
// });
tLCategories.addEventListener("change", function(event){
    const selectedOption = tLCategories.options[tLCategories.selectedIndex]
    const url = selectedOption.getAttribute("data-url")
    window.location.href = url
});

